<template>
  <div class="container pt-5">
    <div class="col-4 offset-4 bg-primary text-white text-center pt-4 pb-4">
      <h4>
        Login
      </h4>
      <form>
        <div class="form-group text-left">
          <label>
            <icon :icon="['fad', 'lock']"/>
            Code</label>
          <input type="password" class="form-control" disabled placeholder="Enter your Auth-Code" v-model="code"
                 required="required">
        </div>
        <div class="form-group pt-4">
          <button class="btn btn-secondary btn-block btn-lg" disabled v-on:click="doLogin">
            <icon :icon="['fad', 'sign-in-alt']"/>
            Login
          </button>
          <div v-if="login.error" class="alert alert-danger mt-5">
            <icon :icon="['fad', 'exclamation']"/>
            Login failed.
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      code: '',
      showError: false
    };
  },
  computed: mapState([
    'login'
  ]),
  mounted() {
    // this.doLogin();
  },
  methods: {
    doLogin() {
      if (window.self !== window.top) {
        this.$store.state.login.authenticated = true
        this.$router.push('/home');
      }
    }
  }
}

</script>

<style scoped>

</style>
